import { Injectable, Injector } from '@angular/core';
import {
  IQFormCardObject,
  QformCard,
  QformNumberInput,
  ViewMode,
} from 'qflow-form-renderer';
import { ComponentData } from '../models/component-data.model';

@Injectable()
export class ComponentDataService {
  constructor() {}

  getComponentsFromCard(card: QformCard, viewMode: ViewMode): ComponentData[] {
    return card
      .getItems()
      .map(item => this.getComponentFromCardObject(item, viewMode));
  }

  getComponentFromCardObject(
    cardObject: IQFormCardObject,
    viewMode: ViewMode
  ): ComponentData {
    const customInjector = this.createInjector(cardObject, viewMode);
    const componentInputs = this.getComponentInputs(cardObject);
    return new ComponentData(
      cardObject.id ?? '',
      cardObject.name,
      cardObject.getComponent(),
      customInjector,
      this.getJsonTypeName(cardObject),
      componentInputs
    );
  }

  private getComponentInputs(
    cardObject: IQFormCardObject
  ): Record<string, unknown> | undefined {
    if (cardObject instanceof QformNumberInput) {
      const inputs: Record<string, unknown> = {};
      Object.defineProperty(inputs, 'qformInputModelValue', {
        enumerable: true,
        get: () => cardObject.value,
      });
      return inputs;
    }

    return undefined;
  }

  private createInjector(
    inputModel: IQFormCardObject,
    viewMode: ViewMode
  ): Injector {
    return Injector.create({
      providers: [
        { provide: inputModel.constructor, useValue: inputModel },
        { provide: ViewMode, useValue: viewMode },
      ],
    });
  }

  private getJsonTypeName(cardObject: IQFormCardObject): string {
    const typeName =
      (cardObject as any)?.getJsonTypeName?.() ??
      cardObject.constructor?.name ??
      '';
    return typeName;
  }
}
